import React from 'react';

import { Checkbox } from 'components/WrappedComponents';
import { FieldProps } from 'components/WrappedComponents/Form/FormWrapper/type';
import { CSSUtils } from 'utils/CSSUtils';

import { ModificationUtilisateurFormValues } from '../ModalModification';

function CheckboxGestionnaireLocal({
  values,
}: FieldProps<ModificationUtilisateurFormValues>): React.ReactElement {
  const key: keyof ModificationUtilisateurFormValues = 'gestionnaireLocal';

  return (
    <Checkbox
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: 'Gestionnaire local',
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      checkboxProps={{}}
    />
  );
}

export default CheckboxGestionnaireLocal;
